export const formFields = {
  subject: {
    id: "Sobre_o_que_deseja_falar__c",
    name: "Sobre_o_que_deseja_falar__c",
    label: "Sobre o que deseja falar",
    placeholder: "Selecione uma opção",
    required: true,
  },
  reason: {
    id: "Motivo_do_contato__c",
    name: "Motivo_do_contato__c",
    label: "Motivo do contato",
    placeholder: "Selecione uma opção",
    required: true,
  },
  subreason: {
    id: "Submotivo_do_contato__c",
    name: "Submotivo_do_contato__c",
    label: "Submotivo do contato",
    placeholder: "Selecione uma opção",
    required: true,
  },
};

export const subjectOptions = [
  { value: "", label: "--None--" },
  { value: "Financeiro (Olist ERP)", label: "Financeiro (Olist ERP)" },
];

/**
 * Returns an array of reason options based on the provided subject.
 *
 * This function takes a subject string and returns corresponding reason options
 * for form selection. Each reason option consists of a value and label property.
 * If no subject is provided or the subject doesn't match any case, a default
 * '--None--' option is returned.
 *
 * @param {string} [subject] - The selected subject that determines which reason options to return
 * @returns {Array<{value: string, label: string}>} An array of reason option objects
 */
export const getReasonOptions = (
  subject?: string
): Array<{ value: string; label: string }> => {
  switch (subject) {
    case "Financeiro (Olist ERP)":
      return [
        {
          value: "Minha conta (Financeiro Olist ERP)",
          label: "Minha conta (Financeiro Olist ERP)",
        },
      ];
    default:
      return [];
  }
};

/**
 * Returns an array of subreason options based on the provided reason.
 *
 * This function takes a reason string and returns corresponding subreason options
 * for form selection. Each reason option consists of a value and label property.
 * If no reason is provided or the subject doesn't match any case, a default
 * '--None--' option is returned.
 *
 * @param {string} [reason] - The selected reason that determines which reason options to return
 * @returns {Array<{value: string, label: string}>} An array of reason option objects
 */
export const getSubReasonOptions = (
  reason?: string
): Array<{ value: string; label: string }> => {
  switch (reason) {
    // FINANCE REASON START
    case "Minha conta (Financeiro Olist ERP)":
      return [
        {
          value: "Alteração da forma de recebimento de cobrança",
          label: "Alteração da forma de recebimento de cobrança",
        },
        {
          value: "Alteração da periodicidade de cobrança",
          label: "Alteração da periodicidade de cobrança",
        },
        {
          value: "Alteração de e-mail do administrador",
          label: "Alteração de e-mail do administrador",
        },
        { value: "Boleto não registrado", label: "Boleto não registrado" },
        { value: "Cancelamento de conta", label: "Cancelamento de conta" },
        {
          value: "Comprovante de pagamento / Promessa / Liberação de conta",
          label: "Comprovante de pagamento / Promessa / Liberação de conta",
        },
        { value: "Detalhamentos cobranças", label: "Detalhamentos cobranças" },
        { value: "Downgrade", label: "Downgrade" },
        { value: "Dúvidas gerais", label: "Dúvidas gerais" },
        { value: "Dúvidas sobre extensões", label: "Dúvidas sobre extensões" },
        { value: "Erro cobrança", label: "Erro cobrança" },
        {
          value: "Nota fiscal de serviço (Solicitação/Dúvidas)",
          label: "Nota fiscal de serviço (Solicitação/Dúvidas)",
        },
        { value: "Reajustes", label: "Reajustes" },
        { value: "Reativação de conta", label: "Reativação de conta" },
        {
          value: "Reenvio do Boleto de mensalidade",
          label: "Reenvio do Boleto de mensalidade",
        },
        { value: "Renegociações", label: "Renegociações" },
        { value: "Renovação de plano", label: "Renovação de plano" },
        {
          value: "Solicitação de boleto antecipado",
          label: "Solicitação de boleto antecipado",
        },
        { value: "Upgrade", label: "Upgrade" },
      ];
    default:
      return [];
  }
};

interface IField {
  type: "text" | "radio" | "select" | "plaintext";
  label: string;
  id?: string;
  options?: { value: string; label: string }[];
}

export const getFieldsByReason = ({
  reason,
  subject,
  subreason,
}: {
  subject: string;
  reason: string;
  subreason?: string;
}): IField[] => {
  if (
    subject === "Financeiro (Olist ERP)" &&
    reason === "Minha conta (Financeiro Olist ERP)"
  ) {
    switch (subreason) {
      case "Alteração da forma de recebimento de cobrança":
      case "Alteração da periodicidade de cobrança":
        return [
          {
            type: "text",
            label: "Qual a alteração gostaria de realizar?",
            id: "Qual_a_alteracao_gostaria_de_realizar__c",
          },
        ];
      case "Alteração de e-mail do administrador":
        return [
          {
            type: "text",
            label: "Você possui acesso ao email cadastrado?",
            id: "Voce_possui_acesso_ao_email_cadastrado__c",
          },
          {
            type: "plaintext",
            label: `Caso não possua, peço que anexe os documentos abaixo:
              Uma foto do seu rosto segurando um documento com foto (ex: RG, CNH),
              o contrato social da empresa ou certificado MEI, uma foto do
              Documento (RG, CNH)`,
          },
        ];
      case "Comprovante de pagamento / Promessa / Liberação de conta":
        return [
          {
            type: "plaintext",
            label:
              "Libere sua conta para uso. Acesse o menu lateral > Minha Conta e clique no botão liberar conta. Na sequência, confirme clicando mais uma vez em liberar conta.",
          },
          {
            type: "plaintext",
            label:
              "Ou caso deseje continuar com a solucitação por favor anexe o comprovante de pagamento para analise e liberação da conta.",
          },
          // TO-DO: Adicionar nova mensagem em plaintext
        ];
      case "Detalhamentos cobranças":
        return [
          {
            type: "text",
            label: "Qual cobrança você se refere?",
            id: "Qual_cobranca_voce_se_refere__c",
          },
        ];
      case "Downgrade":
        return [
          {
            type: "text",
            label: "Você está ciente dos módulos que serão desabilitados?",
            id: "Sabe_dos_modulos_desabilitados__c",
          },
        ];
      case "Dúvidas sobre extensões":
        return [
          {
            type: "text",
            label: "Qual extensão?",
            id: "Qual_extenssao__c",
          },
        ];
      case "Erro cobrança":
        return [
          {
            type: "text",
            label: "Qual erro ocorreu?",
            id: "Qual_erro_ocorreu__c",
          },
        ];
      case "Nota fiscal de serviço (Solicitação/Dúvidas)":
        // TODO: Validar se o campo está correto, na planilha referência "Qual a NF ?"
        return [
          {
            type: "text",
            label: "Qual NF?",
            id: "Qual_NF__c",
          },
        ];
      case "Reativação de conta":
        return [
          {
            type: "text",
            label: "Na sua tela apresenta o valor de reativação?",
            id: "Apresenta_valor_de_reativacao__c",
          },
        ];
      case "Reenvio do Boleto de mensalidade":
        return [
          {
            type: "plaintext",
            label:
              "Precisa da segunda via do boleto? Acesse o menu lateral > Minha Conta > Detalhes de pagamento. Na coluna Formas de pagamento, clique em baixar boleto.",
          },
          {
            type: "text",
            label: "Qual o período?",
            id: "Qual_o_periodo__c",
          },
        ];
      case "Solicitação de boleto antecipado":
        return [
          {
            type: "text",
            label: "Qual o período?",
            id: "Qual_o_periodo__c",
          },
        ];
      case "Upgrade":
        return [
          {
            type: "text",
            label: "Para qual plano você gostaria de migrar?",
            id: "Para_qual_plano_voce_gostaria_de_migrar__c",
          },
        ];
      default:
        return [];
    }
  }

  return [];
};
